import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from './page-header/page-header.component';
import {MatButtonModule} from '@angular/material/button';
import { HoldableDirective } from '@eva-directives/holdable.directive';

@NgModule({
  declarations: [
    PageHeaderComponent,
    HoldableDirective
  ],
  imports: [
    CommonModule,
    MatButtonModule
  ],
  exports: [
    PageHeaderComponent,
    HoldableDirective
  ]
})
export class UiComponentsModule { }
